const styleByType = {
  alert:{
    background:"#f8d7da",
    color:"#58151c",
    border:"1px solid #f1aeb5",
    borderRadius:3,
    linkColor:"#58151c",
    padding:10,
  },
  success:{
    color:"#0a3622",
    background:"#d1e7dd",
    border:"1px solid #a3cfbb",
    borderRadius:3,
    padding:10,
    linkColor:"#0a3622",
  }
}

export default function ReportMessage({children,onEvent,type, style={margin:10}}){


  return (
    <div style={{
      ...styleByType[type]||{},
      ...style,
      whiteSpace:'wrap',
      textOverflow:'wrap',
    }}>
      {children}
    </div>

  )
}
